export default __webpack_public_path__ + "static/media/ic_app_config.559f0959.svg";